<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>派車單 單月統計</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <select
        v-model="year"
        @change="getMonthOptions()"
        class="inputstyle col-md-1 blockmargin"
      >
        <option v-for="(year, index) in years" :value="year" :key="index">
          {{ year }}
        </option>
      </select>
      <select
        @change="getData"
        v-model="month"
        class="inputstyle col-md-1 blockmargin"
      >
        <option v-for="(month, index) in months" :value="month" :key="index">
          {{ month }}
        </option>
      </select>
    </div>
    <el-row :gutter="8">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="text">立即單</span>
          </div>
          <div class="text">
            Line叫車: {{ statisticsTransactionResult.lineChannelTotal }}
          </div>
          <div class="text">
            商家叫車: {{ statisticsTransactionResult.storeChannel }}
          </div>
          <div class="text">
            電話叫車: {{ statisticsTransactionResult.phoneChannel }}
          </div>
          <div class="text">
            總共派單數量:
            {{ statisticsTransactionResult.includeNonDriverMonthlyTotal }}
          </div>
          <div class="text">
            總計(找到司機): {{ statisticsTransactionResult.total }}
          </div>
          <hr />
          <div class="text">
            司機取消: {{ statisticsTransactionResult.driverCancel }}
          </div>
          <div class="text">
            乘客取消: {{ statisticsTransactionResult.passengerCancel }}
          </div>
          <hr />
          <div class="text">
            <el-tooltip content="找到司機的訂單數/總派單數量" placement="top">
              <span>
                派車成功率:
                {{ statisticsTransactionResult.dispatchSuccessRate }}
              </span>
            </el-tooltip>
          </div>
          <div class="text">
            <el-tooltip
              content="(找到司機數-取消數)/找到司機數"
              placement="bottom"
            >
              <span>
                接單後成功率: {{ statisticsTransactionResult.successRate }}
              </span>
            </el-tooltip>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="text">預約單</span>
          </div>
          <div class="text">
            Line叫車: {{ statisticsReservationResult.lineChannelTotal }}
          </div>
          <div class="text">
            商家叫車: {{ statisticsReservationResult.storeChannel }}
          </div>
          <div class="text">
            電話叫車: {{ statisticsReservationResult.phoneChannel }}
          </div>
          <div class="text">
            總共派單數量:
            {{ statisticsReservationResult.includeNonDriverMonthlyTotal }}
          </div>
          <div class="text">
            總計(找到司機): {{ statisticsReservationResult.total }}
          </div>
          <hr />
          <div class="text">
            司機取消: {{ statisticsReservationResult.driverCancel }}
          </div>
          <div class="text">
            乘客取消: {{ statisticsReservationResult.passengerCancel }}
          </div>
          <hr />
          <div class="text">
            <el-tooltip content="找到司機的訂單數/總派單數量" placement="top">
              <span>
                派車成功率:
                {{ statisticsReservationResult.dispatchSuccessRate }}
              </span>
            </el-tooltip>
          </div>
          <div class="text">
            <el-tooltip
              content="(找到司機數-取消數)/找到司機數"
              placement="bottom"
            >
              <span>
                接單後成功率: {{ statisticsReservationResult.successRate }}
              </span>
            </el-tooltip>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-tooltip
              content="針對使用第三方API使用進行計量統計"
              placement="top"
            >
              <span class="text">GoogleAPI、簡訊使用量</span>
            </el-tooltip>
          </div>
          <ul style="list-style-type: disc; padding-left: 20px">
            <li class="text" style="list-style-position: outside">
              <el-tooltip
                content="地址檢索、經緯度對照、地圖預覽的使用次數"
                placement="top"
              >
                <span>GoogleAPI</span>
              </el-tooltip>
            </li>
          </ul>
          <div class="text">
            已使用次數: {{ googleApiUsageResult.usageCount }}
          </div>
          <div class="text">
            預估使用金額: {{ googleApiUsageResult.estimatedCost }}
          </div>
          <hr />
          <ul style="list-style-type: disc; padding-left: 20px">
            <li class="text" style="list-style-position: outside">
              <el-tooltip
                content="Line加入好友時發送簡訊驗證碼的次數以及派車時傳送給乘客的簡訊"
                placement="top"
              >
                <span>簡訊</span>
              </el-tooltip>
            </li>
          </ul>
          <div class="text">已發送則數: {{ smsUsageResult.usageCount }}</div>
        </el-card>
      </el-col>
    </el-row>
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <button
            @click="takeDateTransaction('comprehensive')"
            type="button"
            class="mybtnstyle btn-primary fontSize16"
          >
            下載當月綜合Excel表
          </button>
          <button
            @click="takeDateTransaction('transaction')"
            type="button"
            class="mybtnstyle btn-primary fontSize16"
          >
            下載立即Excel表
          </button>
          <div
            id="bill"
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title" id="exampleModalCenterTitle">
                    選擇日期下載派車單
                  </h3>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <button
                      class="btn btn-default"
                      :class="{ 'btn-warning': downloadRange === 'assign' }"
                      @click="clickDowloadRange('assign')"
                    >
                      找到車訂單
                    </button>
                    <button
                      class="btn btn-default"
                      :class="{ 'btn-warning': downloadRange === 'all' }"
                      @click="clickDowloadRange('all')"
                    >
                      全部訂單
                    </button>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="col-md-2">起始時間：</h4>
                      <DateSelect
                        ref="startTime"
                        class="col-md-12"
                      ></DateSelect>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="col-md-2">結束時間：</h4>
                      <DateSelect ref="endTime" class="col-md-12"></DateSelect>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <el-button
                    type="primary"
                    :loading="loading"
                    @click="onDownload"
                    :disabled="loading"
                  >
                    下載
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-row>
      <el-col>
        <template>
          <el-tabs type="border-card">
            <el-tab-pane label="司機">
              <el-row>
                <el-col :span="2">
                  <h4 class="fontSize16">搜尋關鍵字:</h4>
                </el-col>
                <el-col :span="6">
                  <input
                    v-model="kw"
                    type="text"
                    required="required"
                    class="inputstyle fontSize14"
                    placeholder="隊編/呼號"
                  />
                  <el-button
                    @click="getDriverStatistics"
                    type="primary"
                    size="small"
                  >
                    搜尋
                  </el-button>
                </el-col>
              </el-row>
              <el-table :data="driverList" border style="width: 100%">
                <el-table-column label="隊編/呼號" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.callNumber }}-{{ scope.row.driverName }}
                  </template>
                </el-table-column>
                <el-table-column label="總計(立即單)" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.instant.total }}
                  </template>
                </el-table-column>
                <el-table-column label="成功完成" width="180">
                  <template slot-scope="scope">
                    {{
                      scope.row.instant.total -
                      scope.row.instant.driverCancelCount -
                      scope.row.instant.passengerCancelCount
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="總計(預約單)" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.reservation.total }}
                  </template>
                </el-table-column>
                <el-table-column label="成功完成" width="180">
                  <template slot-scope="scope">
                    {{
                      scope.row.reservation.total -
                      scope.row.reservation.driverCancelCount -
                      scope.row.reservation.passengerCancelCount
                    }}
                  </template>
                </el-table-column>
                <el-table-column label="總計" width="180">
                  <template slot-scope="scope">
                    {{
                      scope.row.instant.total -
                      scope.row.instant.driverCancelCount -
                      scope.row.instant.passengerCancelCount +
                      scope.row.reservation.total -
                      scope.row.reservation.driverCancelCount -
                      scope.row.reservation.passengerCancelCount
                    }}
                  </template>
                </el-table-column>
              </el-table>
              <el-row>
                <el-col :offset="12">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="clickNewPage"
                    :page-size="10"
                    :total="total"
                  ></el-pagination>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import moment from 'moment'
import dayjs from 'dayjs'
import Transaction from '../../assets/js/libs/Transaction'
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import DateSelect from '../../components/tool/DateSelect'

let transaction = new Transaction()
export default {
  name: 'TransactionStatistic',
  components: {
    DateSelect,
  },
  data() {
    return {
      fullPage: false,
      loader: null,
      statisticsTransactionResult: {},
      statisticsReservationResult: {},
      googleApiUsageResult: {},
      smsUsageResult: {},
      years: [],
      months: [],
      year: moment().year(),
      month: moment().month() + 1,
      type: 'driver',
      npp: 10,
      page: 1,
      kw: '',
      list: [],
      total: 0,
      totalPage: 0,
      message: '',
      downloadType: 'transaction',
      downloadRange: 'assign',
      loading: false,
      driverList: [],
    }
  },
  methods: {
    getData() {
      this.page = 1
      this.getDriverStatistics()
      this.getList()
    },
    clickDowloadRange(val) {
      this.downloadRange = val
    },
    transferPercentage(haveDriverTotal, nonDiverTotal) {
      return `${Math.round((haveDriverTotal / nonDiverTotal) * 100) / 100}%`
    },
    takeDateTransaction(value) {
      $('#bill').modal('show')
      this.downloadType = value
    },
    onDownload() {
      let path = ''
      let url = ''
      if (this.downloadType === 'transaction') {
        path = 'excel/transcation-excel'
        console.log('綜合表')
        this.$msg('請至大量作業進度做下載')
      }
      if (this.downloadType === 'comprehensive') {
        path = 'excel/comprehensivelist-excel'
        console.log('excel 表')
        this.$msg('請至大量作業進度做下載')
      }
      if (path === '') {
        alert('下載錯誤, 請重試')
        return
      }
      const params = {
        start: dayjs(this.$refs.startTime.getDate())
          .subtract(8, 'hour')
          .format('YYYY-MM-DD HH:mm'),
        end: dayjs(this.$refs.endTime.getDate())
          .subtract(8, 'hour')
          .format('YYYY-MM-DD HH:mm'),
        downloadRange: this.downloadRange,
      }
      if (location.href.includes('localhost')) {
        url = 'https://staging.download.gladmobile.com'
      } else if (location.href.includes('staging.backstage.gladmobile')) {
        url = 'https://staging.download.gladmobile.com'
      } else if (location.href.includes('backstage.gladmobile.com')) {
        url = 'https://download.gladmobile.com'
      }
      axios
        .post(`${url}/web/api/${path}`, null, {
          headers: { 'x-access-token': cookies.get('user') },
          responseType: 'blob',
          params: params,
        })
        .then(() => {
          const routeUrl = this.$router.resolve({
            path: '/serviceMain/WorkingStatus',
          })
          window.open(routeUrl.href, '_blank')
        })
        .catch((err) => {
          console.log(err)
        })
      return
    },
    getDriverStatistics() {
      let keyword = ''
      if (this.kw !== '' && this.kw !== null) {
        keyword = `&keyword=${this.kw}`
      }
      API.get(
        `driver-v2/statistic?npp=${this.npp}&page=${this.page}&date=${this.year}-${this.month}${keyword}`,
      )
        .then((res) => {
          this.driverList = res.result.array
          this.total = res.result.count
          this.totalPage = Math.ceil(this.total / this.npp)
        })
        .catch((e) => {
          this.$msg('網路連線異常')
          console.error(e)
        })
    },
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    getList() {
      this.showLoading()
      this.list = []
      this.message = '查詢中...'
      transaction
        .getMonthlyStatistic(`${this.year}-${this.month}`)
        .then((res) => {
          console.log(res)
          this.statisticsTransactionResult =
            res.result.statisticsTransactionResult
          this.statisticsReservationResult =
            res.result.statisticsReservationResult
          this.googleApiUsageResult = res.result.apiUsageStatistics.googleApi
          this.smsUsageResult = res.result.apiUsageStatistics.sms
          this.loader.hide()
        })
        .catch((e) => {
          this.loader.hide()
          console.error(e)
        })
    },
    onTitleFinishClick() {
      this.list.sort(function (a, b) {
        let completeA = a.completeOrder // ignore upper and lowercase
        let completeB = b.completeOrder // ignore upper and lowercase
        if (completeA < completeB) {
          return 1
        }
        if (completeA > completeB) {
          return -1
        }
        return 0
      })
    },
    onTitleCancelClick() {
      this.list.sort(function (a, b) {
        let cancelA = a.cancelOrder // ignore upper and lowercase
        let cancelB = b.cancelOrder // ignore upper and lowercase
        if (cancelA < cancelB) {
          return 1
        }
        if (cancelA > cancelB) {
          return -1
        }
        return 0
      })
    },
    onTitleTotalClick() {
      this.list.sort(function (a, b) {
        let totalA = a.orderTotal // ignore upper and lowercase
        let totalB = b.orderTotal // ignore upper and lowercase
        if (totalA < totalB) {
          return 1
        }
        if (totalA > totalB) {
          return -1
        }
        return 0
      })
    },
    onTitleSuccessRateClick() {
      this.list.sort(function (a, b) {
        let successRateA = parseInt(a.successRate.replace('%', '')) // ignore upper and lowercase
        let successRateB = parseInt(b.successRate.replace('%', '')) // ignore upper and lowercase
        if (successRateA < successRateB) {
          return 1
        }
        if (successRateA > successRateB) {
          return -1
        }
        // names must be equal
        return 0
      })
    },
    onSearchBtnClick() {
      this.page = 1
      this.getList()
    },
    clickNewPage(page) {
      this.driverList = []
      this.page = page
      this.getDriverStatistics()
    },
    onTabTypeClick(type) {
      this.list = []
      this.type = type
      this.getList()
    },
    getYearOptions() {
      this.years.push(moment().year())
      if (moment().month() - 5 < 0) {
        this.years.push(moment().year() - 1)
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      if (this.year == moment().year()) {
        for (var i = 0; i < 12; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month <= moment().month() + 1) {
            this.months.push(month)
          }
        }
      } else {
        for (var i = 0; i < 12; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month > moment().month() + 1) {
            this.months.push(month)
          }
        }
      }
    },
  },
  computed: {
    pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
  mounted() {
    this.getList()
    this.getDriverStatistics()
    this.getYearOptions()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text {
  color: black;
  font-size: 16px;
}

/* 讓卡片高度一致 */
.el-row {
  display: flex;
}

.el-col {
  display: flex;
}

.box-card {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.box-card .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/TransactionStatistic.vue